// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KXli","left":"styles_left__2h-HH"};